<template>
  <v-app class="back">
    <v-container fluid>
      <v-row justify="center">
        <v-card class="borda" flat width="1200">
          <v-card-title class="azul_fundo headline">
            <span class="white--text font-weight-bold">{{ formData.plano_nome }}</span>
            <span class="agua ml-5">
              R$
              <span
                v-if="tipo_plano_contratado == 'mensal'"
                v-text="format_valor(formData.plano_valor_mensal)"
              ></span>
              <span
                v-if="tipo_plano_contratado == 'anual'"
                v-text="format_valor(formData.plano_valor_anual)"
              ></span>/mês
            </span>
            <!-- <v-btn @click="step--">--</v-btn> -->
            <!-- <v-btn @click="step++">++</v-btn> -->
            <v-spacer></v-spacer>
            <span class="white--text titulo-primeira-cobranca">Primeira cobrança em:</span>
            <span class="title white--text">
              <span v-text="cobranca()"></span>
            </span>
          </v-card-title>
          <v-card-text>
            <v-stepper v-model="step" class="borda elevation-0">
              <v-stepper-header class="borda elevation-0">
                <v-stepper-step color="#283480" :complete="step > 1" step="1">Dados Pessoais</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#283480" :complete="step > 2" step="2">Dados do Clube</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="#283480" step="3">Confirmação</v-stepper-step>
              </v-stepper-header>
              <v-divider></v-divider>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <div v-if="!login_conta">
                    <div v-if="!nova_conta">
                      <h3 class="text-center">Já possui uma conta de acesso ao Meu Clube?</h3>
                      <v-row justify="center" class="my-8">
                        <v-btn
                          rounded
                          color="#283480"
                          class="white--text mr-3"
                          @click="nova_conta = true"
                        >Não, criar agora!</v-btn>
                        <v-btn
                          rounded
                          color="#00ffd4"
                          class="white--text"
                          @click="login_conta = true"
                        >Sim, fazer login!</v-btn>
                      </v-row>
                    </div>
                  </div>
                  <v-card flat v-if="nova_conta">
                    <v-form ref="form" v-model="valid" @submit.prevent="continuar()">
                      <v-card flat class="borda">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="12" class="mb-n5">
                              <span class="font-weight-bold black--text">Nome *</span>
                              <v-text-field
                                :rules="requiredRules"
                                v-model="dados_associado.usuario_nome"
                                solo
                                dense
                                flat
                                outlined
                                :autofocus="true"
                              ></v-text-field>
                            </v-col>
                            <!-- <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Foto</span>
                              <v-file-input
                                prepend-icon="mdi-camera"
                                solo
                                v-model="dados_associado.usuario_imagem"
                                outlined
                                accept="image/jpg, image/png, image/jpeg"
                                flat
                                dense
                              ></v-file-input>
                            </v-col>-->
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="8" class="mb-n5">
                              <span class="font-weight-bold black--text">Email *</span>
                              <v-text-field
                                :rules="rulesAdicionalEmail"
                                name="email"
                                v-model="dados_associado.usuario_email"
                                solo
                                type="email"
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Senha *</span>
                              <v-text-field
                                :rules="requiredRules"
                                v-model="dados_associado.usuario_senha"
                                @click:append="ver_senha()"
                                :type="senha"
                                solo
                                :append-icon="senha_icone"
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Data de nascimento</span>
                              <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    solo
                                    flat
                                    outlined
                                    dense
                                    @blur="dados_associado.usuario_data_nascimento = parseDate(dateFormatted)"
                                    v-model="dateFormatted"
                                    append-icon="mdi-calendar"
                                    clearable
                                    v-mask="data_mask"
                                    v-on="on"
                                    @input="menu1 = false"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="date"
                                  no-title
                                  ref="picker"
                                  :max="new Date().toISOString().substr(0, 10)"
                                  locale="pt-br"
                                  scrollable
                                  @input="menu1 = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">CPF</span>
                              <v-text-field
                                v-mask="cpf"
                                v-model="dados_associado.usuario_cpf"
                                solo
                                dense
                                flat
                                outlined
                                :rules="rulesAdicionalCPF2"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Telefone</span>
                              <v-text-field
                                v-model="dados_associado.usuario_telefone"
                                solo
                                v-mask="telefone"
                                dense
                                flat
                                outlined
                                :rules="rulesAdicionalTelefone2"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <v-row class="ma-0 pa-0">
                                <v-col md="auto" class="ma-0 pa-0">
                                  <span class="font-weight-bold black--text">CEP</span>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col md="auto" class="ma-0 pa-0">
                                  <span v-if="cep_errado" class="red--text">{{ cep_errado }}</span>
                                </v-col>
                              </v-row>
                              <v-text-field
                                v-model="dados_associado.usuario_cep"
                                solo
                                @input="viaCep"
                                dense
                                v-mask="cep"
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="8" class="mb-n5">
                              <span class="font-weight-bold black--text">Rua</span>
                              <v-text-field
                                v-model="dados_associado.usuario_rua"
                                solo
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Número</span>
                              <v-text-field
                                v-model.number="dados_associado.usuario_numero"
                                solo
                                type="number"
                                dense
                                flat
                                outlined
                                :rules="rulesAdicionalNumero"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Complemento</span>
                              <v-text-field
                                v-model="dados_associado.usuario_complemento"
                                solo
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Bairro</span>
                              <v-text-field
                                v-model="dados_associado.usuario_bairro"
                                solo
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">País</span>
                              <v-autocomplete
                                v-model="dados_associado.usuario_pais"
                                solo
                                dense
                                label="Selecione"
                                :items="paises"
                                :disabled="disable_locais"
                                no-data-text="Não encontrado"
                                flat
                                @input="getEstados"
                                outlined
                              ></v-autocomplete>
                            </v-col>
                            <v-col v-if="brazil == true" cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Estado</span>
                              <v-autocomplete
                                v-model="dados_associado.usuario_estado"
                                solo
                                dense
                                :items="estados"
                                label="Selecione"
                                no-data-text="Não encontrado"
                                flat
                                outlined
                                @input="getCidades"
                              ></v-autocomplete>
                            </v-col>
                            <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Estado</span>

                              <v-text-field
                                :disabled="disable_locais"
                                v-model="dados_associado.usuario_estado"
                                solo
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col v-if="brazil == true" cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Cidade</span>
                              <v-autocomplete
                                v-model="dados_associado.usuario_cidade"
                                no-data-text="Não encontrado"
                                solo
                                dense
                                :items="cidades"
                                label="Selecione"
                                flat
                                outlined
                              ></v-autocomplete>
                            </v-col>
                            <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                              <span class="font-weight-bold black--text">Cidade</span>
                              <v-text-field
                                :disabled="disable_locais"
                                v-model="dados_associado.usuario_cidade"
                                solo
                                dense
                                flat
                                outlined
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-row>
                        <!-- <v-col>
                          <v-btn color="#283480" rounded class="agua" @click="nova_conta = false">
                            <v-icon>mdi-arrow-left</v-icon>
                            <span>Voltar</span>
                          </v-btn>
                        </v-col>-->
                        <v-spacer></v-spacer>
                        <v-col md="auto">
                          <v-btn
                            color="#283480"
                            :loading="loading"
                            :disabled="loading"
                            rounded
                            class="white--text"
                            @click="continuar()"
                          >Continuar</v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  <div v-if="login_conta">
                    <v-row justify="center">
                      <v-card flat width="300">
                        <span
                          class="black--text title font-weight-bold"
                        >Efetue o login para prosseguir</span>
                        <form @submit.prevent="login">
                          <v-text-field
                            class="mb-n4 mt-5"
                            dense
                            solo
                            flat
                            outlined
                            type="email"
                            label="E-mail"
                            name="email"
                            required
                            v-model="form.usuario_email"
                          ></v-text-field>
                          <v-text-field
                            dense
                            solo
                            flat
                            outlined
                            label="Senha"
                            type="password"
                            name="senha"
                            required
                            v-model="form.usuario_senha"
                          ></v-text-field>
                          <v-btn
                            color="#283480"
                            rounded
                            class="white--text mt-n2"
                            :disabled="loading"
                            :loading="loading"
                            type="submit"
                          >Continuar</v-btn>
                          {{errorMessage}}
                        </form>
                      </v-card>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn color="#283480" rounded class="agua" @click="login_conta = false">
                          <v-icon>mdi-arrow-left</v-icon>
                          <span>Voltar</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-form ref="form2" v-model="valid2" @submit.prevent="continuar2()">
                    <v-card flat>
                      <span class="headline">
                        Olá
                        <strong>{{ dados_associado.usuario_nome }}</strong>, preencha os dados do seu clube.
                      </span>
                      <v-row>
                        <v-col cols="12" sm="8" md="8" class="mb-n5">
                          <span class="font-weight-bold black--text">Nome do clube *</span>
                          <v-text-field
                            :rules="requiredRules"
                            v-model="dados_clube.clube_nome_comercial"
                            solo
                            dense
                            flat
                            outlined
                            :autofocus="true"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Logotipo</span>
                          <v-file-input
                            prepend-icon="mdi-camera"
                            solo
                            v-model="dados_clube.clube_logotipo"
                            outlined
                            accept="image/jpg, image/png, image/jpeg"
                            flat
                            dense
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="8" class="mb-n5">
                          <span class="font-weight-bold black--text">Email *</span>
                          <v-text-field
                            :rules="rulesAdicionalEmail"
                            v-model="dados_clube.clube_email"
                            solo
                            type="email"
                            name="email"
                            dense
                            flat
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Telefone *</span>
                          <v-text-field
                            v-model="dados_clube.clube_telefone"
                            solo
                            v-mask="telefone2"
                            dense
                            flat
                            outlined
                            :rules="rulesAdicionalTelefone"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" class="mb-n5" v-if="tenho_cpf">
                          <v-row class="ma-0 pa-0">
                            <v-col md="auto" class="ma-0 pa-0">
                              <span class="font-weight-bold black--text">CPF *</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col md="auto" class="ma-0 pa-0">
                              <a class="blue--text" @click="tenho_cpf = false">Cadastrar CNPJ</a>
                            </v-col>
                          </v-row>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="cpf"
                                v-model="dados_clube.clube_cnpj"
                                solo
                                dense
                                flat
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                :rules="rulesAdicionalCPF"
                              ></v-text-field>
                            </template>
                            <span>
                              Este campo
                              <span class="orange--text">NÃO</span> poderá ser editado
                            </span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="mb-n5" v-else>
                          <v-row class="ma-0 pa-0">
                            <v-col md="auto" class="ma-0 pa-0">
                              <span class="font-weight-bold black--text">CNPJ *</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col md="auto" class="ma-0 pa-0">
                              <a class="blue--text" @click="tenho_cpf = true">Cadastrar CPF</a>
                            </v-col>
                          </v-row>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dados_clube.clube_cnpj"
                                solo
                                v-mask="cnpj_mask"
                                dense
                                flat
                                outlined
                                :rules="rulesAdicionalCNPJ"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <span>
                              Este campo
                              <span class="orange--text">NÃO</span> poderá ser editado
                            </span>
                          </v-tooltip>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="3" class="mb-n5">
                          <span class="font-weight-bold black--text">Tipo de empresa *</span>
                          <v-select
                            :items="select_tipo_empresas"
                            :rules="rulesAdicional"
                            solo
                            v-model="dados_clube.clube_tipo_empresa"
                            outlined
                            flat
                            dense
                          ></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Tipo de clube *</span>
                          <v-select
                            :items="select_tipo_clube"
                            :rules="rulesAdicional"
                            solo
                            v-model="dados_clube.clube_tipo"
                            outlined
                            flat
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Hierarquia *</span>
                          <v-select
                            :items="select_hierarquia"
                            :rules="rulesAdicional"
                            solo
                            outlined
                            v-model="dados_clube.clube_hierarquia"
                            flat
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <v-row class="ma-0 pa-0">
                            <v-col md="auto" class="ma-0 pa-0">
                              <span class="font-weight-bold black--text">CEP *</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col md="auto" class="ma-0 pa-0">
                              <span v-if="cep_errado2" class="red--text">{{ cep_errado }}</span>
                            </v-col>
                          </v-row>
                          <v-text-field
                            v-model="dados_clube.clube_cep"
                            solo
                            @input="viaCep"
                            dense
                            v-mask="cep"
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="8" class="mb-n5">
                          <span class="font-weight-bold black--text">Rua *</span>
                          <v-text-field
                            v-model="dados_clube.clube_rua"
                            solo
                            dense
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Número *</span>
                          <v-text-field
                            v-model.number="dados_clube.clube_numero"
                            solo
                            type="number"
                            dense
                            flat
                            outlined
                            :rules="rulesAdicionalNumero"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Complemento *</span>
                          <v-text-field
                            v-model="dados_clube.clube_complemento"
                            solo
                            dense
                            flat
                            :rules="rulesAdicional"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Bairro *</span>
                          <v-text-field
                            v-model="dados_clube.clube_bairro"
                            solo
                            dense
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">País *</span>
                          <v-autocomplete
                            v-model="dados_clube.clube_pais"
                            solo
                            dense
                            label="Selecione"
                            :items="paises"
                            :disabled="disable_locais2"
                            no-data-text="Não encontrado"
                            flat
                            @input="getEstados"
                            outlined
                            :rules="rulesAdicional"
                          ></v-autocomplete>
                        </v-col>
                        <v-col v-if="brazil2 == true" cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Estado *</span>
                          <v-autocomplete
                            v-model="dados_clube.clube_estado"
                            solo
                            dense
                            :items="estados"
                            label="Selecione"
                            no-data-text="Não encontrado"
                            flat
                            outlined
                            @input="getCidades"
                            :rules="rulesAdicional"
                          ></v-autocomplete>
                        </v-col>
                        <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Estado *</span>

                          <v-text-field
                            :disabled="disable_locais2"
                            v-model="dados_clube.clube_estado"
                            solo
                            dense
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="brazil2 == true" cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Cidade *</span>
                          <v-autocomplete
                            v-model="dados_clube.clube_cidade"
                            no-data-text="Não encontrado"
                            solo
                            dense
                            :items="cidades"
                            label="Selecione"
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-autocomplete>
                        </v-col>
                        <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                          <span class="font-weight-bold black--text">Cidade *</span>
                          <v-text-field
                            :disabled="disable_locais2"
                            v-model="dados_clube.clube_cidade"
                            solo
                            dense
                            flat
                            outlined
                            :rules="rulesAdicional"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-row>
                      <v-col class="mt-n4" md="4">
                        <span class="font-weight-bold black--text">Cupom</span>
                        <v-text-field v-model="dados_clube.cupom" solo flat outlined dense></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col md="auto">
                        <v-btn
                          rounded
                          color="#283480"
                          :loading="loading2"
                          :disabled="loading2"
                          class="white--text"
                          @click="continuar2()"
                        >Continuar</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card flat>
                    <v-row justify="center">
                      <blockquote class="blockquote headline font-weight-light text-center px-10">
                        Obrigado por realizar seu cadastro, você receberá em seu
                        <span
                          class="font-weight-bold"
                        >e-mail</span> informações de
                        <span class="font-weight-bold">pagamento</span> e de
                        <span class="font-weight-bold">acesso</span> ao seu clube.
                      </blockquote>
                      <!-- <blockquote
                        class="blockquote title font-weight-light"
                      >Clique em entrar para acessar o Meu Clube</blockquote>-->
                      <blockquote class="blockquote title font-weight-light text-center">
                        Utilize o
                        <span class="font-weight-bold">link abaixo</span> para acessar seu clube.
                      </blockquote>
                    </v-row>
                    <v-row justify="center">
                      <!-- <v-btn
                        color="#283480"
                        :loading="loadingLogin"
                        :disabled="loadingLogin"
                        class="white--text"
                        @click="login2()"
                      >Entrar</v-btn>-->
                      <blockquote class="blockquote title font-weight-light">
                        <a :href="clubeLink">{{clubeLink}}</a>
                      </blockquote>
                    </v-row>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
        <v-dialog v-model="dialog_termos" width="800px">
          <v-card flat class="borda" height="100%">
            <v-card-title>
              <span class="headline">Termo de confidencialidade</span>
            </v-card-title>
            <v-card-text>
              <embed
                width="100%"
                height="700"
                src="/documents/TERMO_DE_CONFIDENCIALIDADE.pdf"
                type="application/pdf"
              />
            </v-card-text>
            <v-card-actions class="ma-0">
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog_termos = false">Recusar</v-btn>
              <v-btn color="green darken-1" text @click="continuarTermos()">Aceitar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_clubes" max-width="650">
          <v-card class="borda" flat>
            <v-card-title>
              <div class="ml-1" v-if="user">
                <span class="headline">
                  Olá
                  <b>{{user.usuario_nome}}</b>, selecione um clube
                </span>
              </div>
              <span class="headline ma-3"></span>
              <v-spacer></v-spacer>
              <v-btn icon text @click="dialog_clubes = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-2">
              <v-container v-if="user">
                <v-row dense>
                  <v-col
                    cols="6"
                    v-for="(item, index) in user.clubes"
                    :key="index"
                    @click="continuarLogin(item)"
                    style="cursor:pointer;"
                  >
                    <v-card>
                      <v-card-text>
                        <p
                          class="text--primary text-center"
                          style="margin:0;"
                        >{{item.clube_nome_comercial}}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
import Api from "@/common/api.helper";
import axios from "axios";
import * as locais from "../../public/json/cidades.json";
import * as paises from "../../public/json/paises.json";
import { cnpj, cpf } from "cpf-cnpj-validator";
export default {
  data() {
    return {
      tenho_cpf: false,
      dialog_verificar: false,
      rulesAdicionalCPF: [
        v => !!v || "Campo Obrigatório.",
        v => cpf.isValid(v) || "CPF inválido"
      ],
      rulesAdicionalCPF2: [v => !v || cpf.isValid(v) || "CPF inválido"],
      rulesAdicionalCNPJ: [
        v => !!v || "Campo Obrigatório.",
        v => cnpj.isValid(v) || "CNPJ inválido"
      ],
      rulesAdicionalEmail: [
        v => !!v || "Campo Obrigatório.",
        v =>
          /^(([^<>()\\.,;:ç~\s@"]+(\.[^<>()\\.,;:ç~\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            v
          ) || "E-mail inválido"
      ],
      rulesAdicionalTelefone: [
        v => !!v || "Campo Obrigatório.",
        v => (v && v.length >= 14) || "Telefone inválido"
      ],
      rulesAdicionalTelefone2: [
        v => !v || v.length >= 14 || "Telefone inválido"
      ],
      select_tipo_empresas: [
        { text: "Micro Empreendedor Individual", value: "MEI" },
        { text: "Empresa Limitada", value: "LIMITED" },
        { text: "Empresa Individual", value: "INDIVIDUAL" },
        { text: "Associação", value: "ASSOCIATION" }
      ],
      select_tipo_clube: [
        { text: "Aberto", value: "1" },
        { text: "Semiaberto", value: "2" },
        { text: "Fechado", value: "3" }
      ],
      testecpf: "",
      testecnpj: "",
      select_hierarquia: [
        { text: "Clube", value: "1" },
        { text: "Distrito", value: "2" },
        { text: "Distrito Múltiplo", value: "3" }
      ],
      rulesAdicional: [],
      requiredRules: [v => !!v || "Campo Obrigatório."],
      rulesAdicionalNumero: [
        v => v >= 0 || "Número deve ser maior que 0",
        v => /.|,/.test(v) | (v == 0) || "Apenas números permitidos",
        v => Number.isInteger(v) | (v == 0) || "Apenas números inteiros"
      ],
      plano_contratado: this.$route.params.id,
      tipo_plano_contratado: this.$route.params.tipo,
      api_planos: [],
      formData: [],
      step: 1,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: "",
      confirmar: false,
      errorMessage: "",
      loading: false,
      loading2: false,
      login_conta: false,
      nova_conta: true,
      relacionar: {
        id_clube: "",
        id_usuario: ""
      },
      form: {
        usuario_email: "",
        usuario_senha: ""
      },
      dados_clube: {
        clube_nome_comercial: "",
        clube_logotipo: [],
        clube_cnpj: "",
        clube_hierarquia: "",
        clube_tipo: "",
        clube_email: "",
        clube_telefone: "",
        clube_cep: "",
        clube_rua: "",
        clube_numero: "",
        clube_complemento: "",
        clube_bairro: "",
        clube_cidade: "",
        clube_estado: "",
        clube_pais: "",
        clube_tipo_empresa: 'ASSOCIATION',
        asaas_walletId: "",
        cupom: "",
        fk_id_usuario: "",
        fk_id_plano: this.$route.params.id,
        clube_tipo_plano: this.$route.params.tipo == "mensal" ? 1 : 2
      },
      dados_associado: {
        usuario_nome: "",
        usuario_imagem: [],
        usuario_imagemNew: [],
        usuario_imagem_delete: 0,
        usuario_email: "",
        usuario_senha: "",
        usuario_telefone: "",
        usuario_data_nascimento: "",
        usuario_cpf: "",
        usuario_cep: "",
        usuario_rua: "",
        usuario_numero: "",
        usuario_complemento: "",
        usuario_bairro: "",
        usuario_cidade: "",
        usuario_estado: "",
        usuario_pais: "",
        fk_id_perfil: "1",
        grupo: "",
        plano: ""
      },
      valid: true,
      valid2: true,
      senha_icone: "mdi-18px mdi-eye",
      senha: "password",
      menu1: false,
      brazil: false,
      disable_locais: false,
      loadingLogin: false,
      cep_errado: "",
      brazil2: false,
      disable_locais2: false,
      cep_errado2: "",
      cidades: [],
      estados: [],
      paises: [],
      cnpj_mask: "##.###.###/####-##",
      data_mask: "##/##/####",
      cpf: "###.###.###-##",
      cep: "#####-###",
      user: "",
      dialog_clubes: false,
      dialog_termos: false,
      erro_email: false,
      erro_cpf: false,
      send_email: {
        usuario_email: ""
      },
      send_cpf: {
        usuario_cpf: ""
      },
      clubeLink: ""
    };
  },
  created() {
    this.getPlanos();
    this.getPaises();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    telefone() {
      let telefone = "";
      if (this.dados_associado.usuario_telefone.length > 14) {
        telefone = "(##) # ####-####";
      } else {
        telefone = "(##) ####-####";
      }
      return telefone;
    },
    telefone2() {
      let telefone = "";
      if (this.dados_clube.clube_telefone.length > 14) {
        telefone = "(##) # ####-####";
      } else {
        telefone = "(##) ####-####";
      }
      return telefone;
    }
  },
  watch: {
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.dados_associado.usuario_data_nascimento = this.parseDate(
        this.dateFormatted
      );
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    validar_email() {
      this.send_email.usuario_email = this.dados_associado.usuario_email;
      Api.post("/usuarios/valida-cpf-email", this.send_email)
        .then(response => {
          if (response.data.error) {
            // this.$toast.error(response.data.errors);
            this.erro_email = false;
          } else {
            this.erro_email = false;
          }
        })
        .catch(err => {
          this.$toast.error(err);
          throw err;
        });
    },
    validar_cpf() {
      this.send_cpf.usuario_cpf = this.dados_associado.usuario_cpf;
      Api.post("/usuarios/valida-cpf-email", this.send_cpf)
        .then(response => {
          if (response.data.error) {
            this.$toast.warning(response.data.errors);
            this.erro_cpf = true;
          } else {
            this.erro_cpf = false;
          }
        })
        .catch(err => {
          this.$toast.error(err);
          throw err;
        });
    },
    cobranca() {
      return moment(new Date().toISOString().substr(0, 10))
        .add(Number(this.formData.plano_tempo_avaliacao), "days")
        .format("L");
    },
    getPlanos() {
      this.loading = true;
      Api.get(`/planos/` + this.$route.params.id)
        .then(response => {
          if (response.data.length > 0) {
            this.api_planos = response.data;
            this.formData = this.api_planos[0];
            this.loading = false;
          } else {
            this.$toast.error("Plano não disponível!");
            setTimeout(() => {
              this.$router.push({ name: "Home" });
            }, 2000);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error(err);
          throw err;
        });
    },
    login() {
      this.loading = true;
      Api.post("/login", this.form)
        .then(response => {
          this.loading = false;
          if (response.data.error) {
            this.errorMessage = response.data.error;
          } else {
            this.errorMessage = "";
            this.relacionar.id_usuario = response.data.id_usuario;
            this.dados_clube.fk_id_usuario = response.data.id_usuario;
            this.dados_associado.usuario_nome = response.data.usuario_nome;
            this.step = 2;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error(err);
          throw err;
        });
    },
    ver_senha() {
      if (this.senha == "password") {
        this.senha = "";
        this.senha_icone = "mdi-18px mdi-eye-off";
      } else {
        this.senha = "password";
        this.senha_icone = "mdi-18px mdi-eye";
      }
    },
    viaCep() {
      if (this.step == 1) {
        if (this.dados_associado.usuario_cep) {
          if (this.dados_associado.usuario_cep.length != 9) {
            this.brazil = true;
            this.disable_locais = false;
          } else {
            axios
              .get(
                "https://viacep.com.br/ws/" +
                  this.dados_associado.usuario_cep +
                  "/json"
              )
              .then(response => {
                if (response.data.erro == true) {
                  this.cep_errado = "CEP não encontrado";
                  this.brazil = true;
                  this.disable_locais = false;
                } else {
                  this.brazil = false;
                  this.disable_locais = true;
                  this.dados_associado.usuario_rua = response.data.logradouro;
                  this.dados_associado.usuario_cidade =
                    response.data.localidade;
                  this.dados_associado.usuario_bairro = response.data.bairro;
                  this.dados_associado.usuario_estado = response.data.uf;
                  this.dados_associado.usuario_pais = "Brasil";
                  this.cep_errado = "";
                  for (let i = 0; i < locais.default.estados.length; i++) {
                    if (response.data.uf === locais.default.estados[i].sigla) {
                      this.dados_associado.usuario_estado =
                        locais.default.estados[i].nome;
                    }
                  }
                }
              });
          }
        }
      } else if (this.step == 2) {
        if (this.dados_clube.clube_cep) {
          if (this.dados_clube.clube_cep.length != 9) {
            this.brazil2 = true;
            this.disable_locais2 = false;
          } else {
            axios
              .get(
                "https://viacep.com.br/ws/" +
                  this.dados_clube.clube_cep +
                  "/json"
              )
              .then(response => {
                if (response.data.erro == true) {
                  this.cep_errado2 = "CEP não encontrado";
                  this.brazil2 = true;
                  this.disable_locais2 = false;
                } else {
                  this.brazil2 = false;
                  this.disable_locais2 = true;
                  this.dados_clube.clube_rua = response.data.logradouro;
                  this.dados_clube.clube_cidade = response.data.localidade;
                  this.dados_clube.clube_bairro = response.data.bairro;
                  this.dados_clube.clube_estado = response.data.uf;
                  this.dados_clube.clube_pais = "Brasil";
                  this.cep_errado2 = "";
                  for (let i = 0; i < locais.default.estados.length; i++) {
                    if (response.data.uf === locais.default.estados[i].sigla) {
                      this.dados_clube.clube_estado =
                        locais.default.estados[i].nome;
                    }
                  }
                }
              });
          }
        }
      }
    },
    getPaises() {
      for (let i = 0; i < paises.default.length; i++) {
        this.paises.push({
          text: paises.default[i].nome_pais + ", " + paises.default[i].sigla,
          value: paises.default[i].nome_pais
        });
      }
    },
    getEstados() {
      if (
        this.dados_associado.usuario_pais == "Brasil" ||
        this.dados_clube.clube_pais == "Brasil"
      ) {
        this.brazil = true;
        this.brazil2 = true;
        for (let i = 0; i < locais.default.estados.length; i++) {
          this.estados.push({
            text: locais.default.estados[i].nome,
            value: locais.default.estados[i].nome
          });
        }
      } else {
        this.brazil = false;
        this.brazil2 = false;
      }
    },
    getCidades() {
      this.cidades = [];
      for (let i = 0; i < locais.default.estados.length; i++) {
        if (
          this.dados_associado.usuario_estado === locais.default.estados[i].nome
        ) {
          for (let j = 0; j < locais.default.estados[i].cidades.length; j++) {
            this.cidades[j] = locais.default.estados[i].cidades[j];
          }
        }
        if (this.dados_clube.clube_estado === locais.default.estados[i].nome) {
          for (let j = 0; j < locais.default.estados[i].cidades.length; j++) {
            this.cidades[j] = locais.default.estados[i].cidades[j];
          }
        }
      }
    },
    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },
    continuar() {
      this.loading = true;

      if (this.erro_email) {
        this.$toast.error("E-mail já cadastrado");
      } else {
        if (this.erro_cpf) {
          this.$toast.error("CPF já cadastrado");
        } else {
          if (this.$refs.form.validate()) {
            if (this.dados_associado.usuario_numero == 0) {
              this.dados_associado.usuario_numero = 1;
            }
            let formData = new FormData();
            Object.keys(this.dados_associado).map(key => {
              if (key === "usuario_imagem") {
                let file = this.dados_associado.usuario_imagem;
                if (this.dados_associado.usuario_imagem) {
                  if (this.dados_associado.usuario_imagem.name) {
                    formData.append(
                      `usuario_imagem`,
                      file,
                      `${new Date().getTime()}.${this.getExtension(
                        this.dados_associado.usuario_imagem.name
                      )}`
                    );
                  }
                }
              } else {
                if (this.dados_associado[key]) {
                  formData.append(key, this.dados_associado[key]);
                }
              }
            });
            Api.post("/usuarios/nova-conta", formData)
              .then(response => {
                this.loading = false;
                if (!response.data.errors) {
                  this.$toast.success("1ª etapa finalizada com sucesso!");
                  this.relacionar.id_usuario = response.data.id_usuario;
                  this.dados_clube.fk_id_usuario = response.data.id_usuario;
                  this.step = 2;
                } else {
                  this.$toast.warning(response.data.errors);
                }
              })
              .catch(err => {
                this.loading = false;
                this.$toast.error(err);
                throw err;
              });
          } else {
            this.loading = false;
          }
        }
      }
    },
    continuar2() {
      this.loading2 = true;
      if (this.$refs.form2.validate()) {
        if (this.dados_clube.clube_numero == 0) {
          this.dados_clube.clube_numero = 1;
        }
        let formData = new FormData();
        Object.keys(this.dados_clube).map(key => {
          if (key === "clube_logotipo") {
            let file = this.dados_clube.clube_logotipo;
            if (this.dados_clube.clube_logotipo) {
              if (this.dados_clube.clube_logotipo.name) {
                formData.append(
                  `clube_logotipo`,
                  file,
                  `${new Date().getTime()}.${this.getExtension(
                    this.dados_clube.clube_logotipo.name
                  )}`
                );
              }
            }
          } else {
            if (this.dados_clube[key]) {
              formData.append(key, this.dados_clube[key]);
            }
          }
        });
        Api.post("/clubes/store", formData)
          .then(response => {
            if (!response.data.errors) {
              this.relacionar.id_clube = response.data.id_clube;
              this.user_clube();
              this.clubeLink =
                Api.getAplicationUrl() + response.data.clube_slug;
              this.loading2 = false;
            } else {
              this.$toast.warning(response.data.errors);
              this.loading2 = false;
            }
          })
          .catch(err => {
            this.loading2 = false;
            this.$toast.error(err);
            throw err;
          });
      } else {
        this.loading2 = false;
      }
    },
    user_clube() {
      Api.post("/usuarios/relacionar", this.relacionar)
        .then(response => {
          if (!response.data.errors) {
            this.loading2 = false;
            this.$toast.success("2ª etapa finalizada com sucesso!");
            this.step = 3;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.loading2 = false;
          this.$toast.error(err);
          throw err;
        });
    },
    login2() {
      this.loadingLogin = true;
      if (!this.form.usuario_email) {
        this.form.usuario_email = this.dados_associado.usuario_email;
      }
      if (!this.form.usuario_senha) {
        this.form.usuario_senha = this.dados_associado.usuario_senha;
      }
      Api.post("/login", this.form)
        .then(response => {
          this.loadingLogin = false;
          if (response.data.error) {
            this.errorMessage = response.data.error;
          } else {
            this.errorMessage = "";
            this.user = response.data;
            if (!this.user.usuario_termos) {
              localStorage.setItem("token", this.user.clubes[0].clube_token);
              localStorage.setItem("user-token", this.user.usuario_token);
              localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
              localStorage.setItem(
                "clube-atual",
                JSON.stringify(this.user.clubes[0])
              );
              this.dialog_termos = true;
              return false;
            }
            if (this.user.clubes.length > 1) {
              this.dialog_clubes = true;
            } else {
              localStorage.setItem("token", this.user.clubes[0].clube_token);
              localStorage.setItem("user-token", this.user.usuario_token);
              localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
              localStorage.setItem(
                "clube-atual",
                JSON.stringify(this.user.clubes[0])
              );
              this.$router.push({ name: "Fluxo" });
            }
          }
        })
        .catch(err => {
          this.$toast.error(err);
          this.loadingLogin = false;
          throw err;
        });
    },
    continuarTermos() {
      Api.post(`/usuario-termos/${this.user.id_usuario}`)
        .then(response => {
          if (response) {
            this.dialog_termos = false;
          }
          this.dialog_termos = false;
          if (this.user.clubes.length > 1) {
            this.dialog_clubes = true;
          } else {
            this.$router.push({ name: "Fluxo" });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error(err);
          throw err;
        });
    },
    continuarLogin(item) {
      if (item.clube_token) {
        localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
        localStorage.setItem("token", item.clube_token);
        localStorage.setItem("user-token", this.user.usuario_token);
        this.dialog_clubes = false;
        this.$router.push({ name: "Fluxo" });
      }
    },
    format_valor(valor) {
      if (valor) {
        return valor
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      }
    }
  }
};
</script>
<style>
.azul_fundo {
  background-color: #283480;
}
.titulo-primeira-cobranca {
  font-size: 13px !important;
  padding-right: 10px;
}
</style>